import React from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {Helmet} from 'react-helmet'
import './index.scss'
import CartBar from './CartBar'
import Order from './Order'
import locationsData from './locationsData'

// ── Los Amigos Mexican Restaurant — multi-location ordering app ──────────────
// Burbank + Santa Clarita. Structure follows Blosomall (locations array →
// per-basePath routers in src/index.js), with one difference: the marketing
// homepage is the separate Astro site (../../../../Code/evsites/losamigos),
// stitched in at deploy time by ./_redirects, so this app owns "/order" (the
// location selector) rather than "/". Look & feel is Baldwin's ordering theme
// recolored to the Los Amigos green/yellow/orange logo — see index.scss.

// Paths on which the shared <AutoMenu> ordering view renders inside each
// location's router. "/" is intentionally excluded (Default404NotFound only
// opts out of /order and /menu); it redirects to /order below instead.
export const customOrderAppPaths = ["/menu", "/order"]

// Sticky top bar across the ordering flow (menu / product / cart).
export {CartBar as StickyTopBar}

// Consumed by src/index.js Root — one router per location basePath. The
// shared AutoMenuHeader renders the location header + switcher automatically
// because more than one location is exported here.
export {locationsData as locations}

export const pages = [
  // Location root (e.g. /burbank/) → straight into the menu.
  {path: "/", component: () => <Redirect to="/order" />},
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
]

export function SiteNav ({shopId}) {
  const location = locationsData.find(l => l.shopId === shopId)
  return (
    <Helmet>
      <title>{`Order Online${location ? ` ${location.label}` : ''} — Los Amigos Mexican Restaurant`}</title>
      <meta name="theme-color" content="#1f8a4d" />
    </Helmet>
  )
}

// Catch-all outside the location basePaths. "/order" is the location selector.
// "/" is the Astro marketing homepage in production (Netlify rewrites it to
// site.html before React ever loads); the "/" route below is what you get in
// local dev, where nothing serves the marketing site.
export function MultilocationHome () {
  return (
    <div className="site-content losamigosall">
      <Helmet>
        <meta name="theme-color" content="#1f8a4d" />
      </Helmet>
      <Switch>
        <Route path="/order" component={Order} />
        <Route path="/" component={Order} />
      </Switch>
    </div>
  )
}

// Same menu-tag behavior as the original Losamigos site (the two locations
// share the losamigos menu).
export function subMenuFilter (subMenu) {
  const tag = subMenu.tag
  if (!tag) { return true }

  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() // 0 to 23

  const isTuesday = day === 2
  const isTuesdayMenu = tag.indexOf('taco-tuesday') !== -1
  const isLunchMenu = tag.indexOf('lunch-specials') !== -1

  if (isTuesdayMenu) {
    return isTuesday && (hours >= 14) && (hours < 19)
  }

  if (isLunchMenu) {
    return (hours > 10) && (hours < 15)
  }

  return true
}
